import { useState } from "react";
import { MetadataDashboardTemplate } from "@/components/Templates/MetadataDashboardTemplate";
import { useScopeParams } from "@/hooks/useScopeParams";
import PageHeader from "@/components/UI/PageHeader";
import { TabsSwitcher } from "@/components/UI/TabsSwitcher";

export default function IpAdministration() {
  const { id } = useScopeParams();

  const tabItems = [
    {
      label: "Check-Ins",
      key: "dosage_ip_administration",
      constants: {
        wikiLink: "/wiki/guides/exploration-safety-ip-admin",
        idLink: (subjectId: string) =>
          `/${id}/subjects/overview/${subjectId}/ip-administration`,
      },
    },
    {
      label: "Missed Doses",
      key: "dosage_missed_dosing",
      constants: {
        wikiLink: "/wiki/guides/exploration-safety-ip-admin",
        idLink: (subjectId: string) =>
          `/${id}/subjects/overview/${subjectId}/missed-dosing`,
      },
    },
  ];

  const [activeTab, setActiveTab] = useState(tabItems[0]);

  return (
    <div className="w-full p-4">
      <div className="flex justify-between mb-4">
        <div className="flex gap-2">
          <PageHeader
            title="Safety: IP Administration"
            tooltipText={tooltipText}
          />
        </div>
        {id !== "DARATU-ALZ" && (
          <div className="flex items-center">
            <TabsSwitcher
              tabItems={tabItems}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          </div>
        )}
      </div>
      <MetadataDashboardTemplate
        type={activeTab.key}
        constants={activeTab.constants}
        subjectId={undefined}
      />
    </div>
  );
}
const tooltipText =
  "View a high level overview of the amount of study intervention administered per subject per timepoint.";
